import { useEffect } from "react";
import { BsLinkedin, BsGithub, BsTwitter } from "react-icons/bs";

import { ImFacebook } from "react-icons/im";
import { HiMail } from "react-icons/hi";
import { IoLocationSharp } from "react-icons/io5";
import { changePageState, Page } from "../Interfaces";
import profile from "../images/profile.jpg";

const Home = ({ setCurrentPage }: changePageState) => {
  useEffect(() => setCurrentPage(Page.home), [setCurrentPage]);
  const MAIL = "musyajuaayush@gmail.com";
  const LOCATION = "Kathmandu, Nepal";

  return (
    <div className="home flex flex-c flex-ac">
      <div className="home__left">
        <img src={profile} alt="" className="home__left__profile" />
        <div className="home__left__mail flex flex-ac">
          <HiMail className="home__left__mail__icon" />
          <span>{MAIL}</span>
        </div>
        <div className="home__left__location flex flex-ac">
          <IoLocationSharp className="home__left__location__icon" />
          <span>{LOCATION}</span>
        </div>
      </div>

      <div className="home__separator"></div>
      <div className="home__right">
        <div className="home__right__intro">
          Hey,<br></br>I'm Aayush musyaju
        </div>
        <div className="home__right__icons">
          <a href="https://github.com/aayush-musyaju" className="home__github">
            <BsGithub className="icon_test" />
          </a>
          <a
            href="https://www.linkedin.com/in/aayush-musyaju-9a03311ab/"
            className="home__linkedin"
          >
            <BsLinkedin className="icon_test" />
          </a>
        </div>
        <div className="home__right__about">
       Hi! I'm a computer engineering undergraduate who loves learning new things and finding creative ways to solve problems. I'm always curious and enjoy exploring fresh ideas, especially when I get to build something that helps others in their everyday lives. Working on meaningful projects that make a real difference in the world is what motivates me most.
        </div>
      </div>
    </div>
  );
};

export default Home;
